/*
 * Created Date: 16-01-2024, 10:16:40 pm
 * Author: Victor
 * Email: victor@pt-corp.vn
 * -----
 * Last Modified:
 * Modified By:
 * -----
 * Copyright (c) 2024 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import i18n from 'i18next'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

i18n.use(Backend)
	.use(initReactI18next)

	.init({
		backend: {
			loadPath: () => {
				// const query = getQueryUrlObject()
				// console.log('=======> query', query)
				return '/locales/{{lng}}/{{ns}}.json'
			},
			allowMultiLoading: true,
			addPath: '/api/locales/add/{{lng}}',
			parsePayload: (namespace, key, fallbackValue) => ({ namespace, keys: { [key]: fallbackValue || '' } })

			// parse(data) {
			// 	const newData = flatten(JSON.parse(data))
			// 	console.log('============= data', JSON.stringify(newData))
			// 	return newData
			// }
			// parse,
		},
		// preload: ['vi'],
		fallbackLng: 'vi',
		lng: 'vi',
		debug: true,
		ns: ['common'],
		defaultNS: 'common',
		interpolation: {
			escapeValue: false // not needed for react as it escapes by default
		},
		saveMissing: true,
		appendNamespaceToMissingKey: true,
		partialBundledLanguages: true
	})

export default i18n
